let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4Lql5")).then(() => parcelRequire('iZn0V'));